import { clsx, type ClassValue } from "clsx"
import { extendTailwindMerge } from "tailwind-merge"

// Oficina Virtual F4 (spec 004 T3) — teach twMerge the custom numeric font
// weights from tailwind.config.js. Without this, `cn('font-medium',
// 'font-600')` keeps BOTH classes and the stylesheet order decides (custom
// numeric weights are emitted BEFORE `font-medium`, so the skin would lose).
const twMerge = extendTailwindMerge({
  extend: {
    classGroups: {
      "font-weight": ["font-450", "font-550", "font-600"],
      // Rebrand Apple (03-11-2026) — the oficina type scale and radii. Without this, twMerge reads `text-o-nota` as a
      // text COLOR and drops it next to `text-oficina-texto3` (the size silently fell back to the inherited one).
      "font-size": [{ text: ["o-mini", "o-nota", "o-sub", "o-texto", "o-cuerpo", "o-titulo3", "o-titulo2", "o-titulo", "o-cifra", "o-cifra-grande"] }],
      rounded: [{ rounded: ["o-s", "o-m", "o-l", "o-xl"] }],
      shadow: [{ shadow: ["o-flota", "o-hoja"] }],
    },
  },
})

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}
